import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

/* eslint-disable import/no-webpack-loader-syntax */
import DiskWiper from "-!svg-react-loader!../../images/icn-DiskWiper.svg";
/* eslint-enable import/no-webpack-loader-syntax */

import FormattedDate from "../FormattedDate";
import LoadingOverlay from "../loading-overlay";
import ReportSummary from "../report-summary";
import RightSideBar from "../report-preview-side-bar";
import { ReportDto, SortOrder } from "src/services";
import { IRootState } from "src/reducers";
import { connect } from "react-redux";
import { reportChangePageAction, reportChangeSortAction } from "src/actions";
import ReportPreviewModal from "src/components/report-preview-modal";
import { printReport, downloadReport } from "src/helpers/report-utils";


import "./styles.css";
import { FormattedMessage } from 'react-intl';
// import Checkbox from '../Checkbox';

interface IProps extends RouteComponentProps {
  entries: any[];
  isDataLoading: boolean;
  page: number;
  pageSize: number;
  sortBy: string;
  sortOrder: SortOrder;
  reportChangePageAction: any;
  reportChangeSortAction: any;
}

interface IState {
  isRightSidebarOpen: boolean;
  isReportModalShown: boolean;
  isEditModalShown: boolean;
  currentId: string | null;
  currentDescription: string | null;
  currentName: string | null;
  currentCreationTime: string | null;
  currentReport: ReportDto;
  errorInfo: string | null;
}

class Table extends React.Component<IProps, IState> {
  private tableContainer: React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    this.state = {
      currentCreationTime: null,
      currentDescription: null,
      currentId: null,
      currentName: null,
      currentReport: new ReportDto(),
      errorInfo: null,
      isEditModalShown: false,
      isReportModalShown: false,
      isRightSidebarOpen: false
    };

    this.handleHide = this.handleHide.bind(this);
    this.hanleOpenReportPreviewModal = this.hanleOpenReportPreviewModal.bind(this);
  }

  public componentDidMount() {
    document.body.classList.remove("login-body-theme");
    document.body.classList.add("main-body-theme");

    this.props.reportChangePageAction(1, 25);
  }

  public handleDiscardEdit = () => {
    this.setState({
      currentDescription: "",
      currentId: null,
      isEditModalShown: false
    });
  };

  public handleHide() {
    this.setState({ isEditModalShown: false, isReportModalShown: false });
  }

  
  public showReport = (id: number) => {
    this.setState({ currentReport: this.props.entries.find(e => e.id === id), isRightSidebarOpen: true });
  };

  public render() {
    const Sort = () => (
      <React.Fragment>
        {this.props.sortOrder === SortOrder.Asc ? (
          <span className="glyphicon glyphicon-triangle-top" />
        ) : (
          <span className="glyphicon glyphicon-triangle-bottom" />
        )}
      </React.Fragment>
    );

    return (
      <main className="main-container">
        <RightSideBar
          title={this.state.currentReport ? this.state.currentReport.name : ""}
          isOpen={this.state.currentReport != null && this.state.isRightSidebarOpen}
          width="330px"
          onClose={() => this.setState({ isRightSidebarOpen: false })}
          onOpen={() => this.setState({ isReportModalShown: true })}
        >
          <ReportSummary report={this.state.currentReport} />
        </RightSideBar>
        <ReportPreviewModal
          show={this.state.isReportModalShown}
          handleHide={() => this.setState({ isReportModalShown: false })}
          handleKeyPress={e =>
            e && e.charCode === 13 && downloadReport(this.state.currentReport.id, this.state.currentReport)
          }
          handlePrint={() => this.handlePrintReport(this.state.currentReport)}
          handleDownload={() => downloadReport(this.state.currentReport.id, this.state.currentReport)}
          report={this.state.currentReport}
        />
        <LoadingOverlay isLoading={this.props.isDataLoading} />
        <div className="main_table">
          <table className="table report_table">
            <thead>
              <tr>
                <th style={{ width: "30%" }}>
                  <FormattedMessage
                    id="report-table.header.name"
                    defaultMessage={`Name`}
                  />
                </th>
                <th style={{ width: "15%" }}>
                  <button onClick={() => this.handleSortClick()}>
                    <FormattedMessage
                      id="report-table.header.creationTime"
                      defaultMessage={`Creation time`}
                    />
                    &nbsp; <Sort/>
                  </button>
                </th>
                <th style={{ width: "10%" }}>
                  <FormattedMessage
                      id="report-table.header.type"
                      defaultMessage={`Name`}
                    />
                </th>
                <th className="report_header_description" style={{ width: "35%" }}>
                <FormattedMessage
                    id="report-table.header.description"
                    defaultMessage={`Description`}
                  />
                </th>
              </tr>
            </thead>
          </table>
          <div className="main_table_scroll_wrapper" ref={this.tableContainer}>
            <table className="table report_table">
              <tbody>
                {this.props.entries.map(entry => (
                  <tr
                    key={entry.id}
                    onClick={() => {
                      this.showReport(entry.id);
                    }}
                  >
                    {/* <td className="column-checkbox">
                      <Checkbox 
                        checked={this.state.currentId === entry.id} 
                        value={entry.id} 
                        onChange={(val, checked)=> this.setState({currentId: val})}
                    /></td> */}
                    <td className="report_col_name" style={{ width: "30%" }}>
                      <div>{entry.name}</div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <FormattedDate date={entry.creationTime} />
                    </td>

                    <td style={{ width: "10%" }}>
                      <DiskWiper height="16" width="16" title="" />
                      {entry.reportType}
                    </td>
                    <td className="report_col_description" style={{ width: "35%" }}>
                      <div className="report_table__description">{entry.description}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ height: "100px" }} />
          </div>
        </div>
      </main>
    );
  }

  public hanleOpenReportPreviewModal(): void {
    this.setState({ isReportModalShown: true });
  }

  private handlePrintReport = (report: ReportDto) => {
    const newWindow = window.open("", "_blank")

    printReport(report, newWindow)
  }

  private handleSortClick = () => {
    const nextOrder = this.props.sortOrder === SortOrder.Asc ? SortOrder.Desc : SortOrder.Asc
    this.props.reportChangeSortAction({ sortBy: 'creationTime', order: nextOrder})
  }
}

const mapStateToProps = (state: IRootState) => ({
  entries: state.reports.entities,
  isDataLoading: state.reports.isLoading,
  sortBy: state.reports.sort!.sortBy,
  sortOrder: state.reports.sort!.order,
});

export default connect(
  mapStateToProps,
  { reportChangePageAction, reportChangeSortAction }
)(withRouter(Table));



// WEBPACK FOOTER //
// ./src/components/report-table/index.tsx